import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOnline: navigator.onLine,
  isSyncing: false,
};

const networkSlice = createSlice({
  name: "network",
  initialState,
  reducers: {
    setOnlineStatus: (state, action) => {
      state.isOnline = action.payload;
    },
    setSyncingStatus: (state, action) => {
      state.isSyncing = action.payload;
    },
  },
});

export const { setOnlineStatus, setSyncingStatus } = networkSlice.actions;
export default networkSlice.reducer;
